import { render, staticRenderFns } from "./mailMessages.vue?vue&type=template&id=53fd2be9&scoped=true&"
import script from "./mailMessages.vue?vue&type=script&lang=js&"
export * from "./mailMessages.vue?vue&type=script&lang=js&"
import style0 from "./mailMessages.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mailMessages.vue?vue&type=style&index=1&id=53fd2be9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd2be9",
  null
  
)

export default component.exports